import { selectToken, selectTokenExp, store } from "../Store.js";
export function validateToken() {
    const token = selectToken(store.getState());
    if (!token) {
        console.log("No authentication token found");
        window.location.href = `/?return=${window.location.href}`;
    }
    else {
        const exp = selectTokenExp(store.getState());
        if (exp * 1000 < new Date().valueOf()) {
            console.log("token expired");
            window.location.href = `/?expired=true&return=${window.location.href}`;
        }
    }
}
//# sourceMappingURL=AuthenticationUtils.js.map